import { useEffect } from "react";
import { MapContainer, TileLayer, Polygon, Circle, CircleMarker, Tooltip, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function Clicks({ onClick }) {
  useMapEvents({ click: (e) => onClick([e.latlng.lat, e.latlng.lng]) });
  return null;
}

function FitTo({ target }) {
  const map = useMap();
  useEffect(() => {
    if (!target) return;
    if (target.length === 1) map.setView(target[0], 16);
    else if (target.length > 1) map.fitBounds(L.latLngBounds(target).pad(0.2), { maxZoom: 18 });
  }, [map, target]);
  return null;
}

export function LocateMap({ mode, polygon, center, radius, results, fit, onClick, selected }) {
  return (
    <div className="border-2 border-black h-[420px] sm:h-[520px] relative z-0 isolate bg-[#0B0B0B]" data-testid="locate-map">
      <MapContainer center={[39.5, -98.35]} zoom={4} className="h-full w-full" scrollWheelZoom>
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" className="survey-tiles" maxZoom={19} />
        <Clicks onClick={onClick} />
        <FitTo target={fit} />
        {mode === "area" && polygon.length > 0 && (
          <Polygon positions={polygon} pathOptions={{ color: "#22d3ee", weight: 2, fillOpacity: 0.12, dashArray: polygon.length < 3 ? "4 4" : null }} />
        )}
        {mode === "area" && polygon.map((p, i) => <CircleMarker key={`v${i}`} center={p} radius={5} pathOptions={{ color: "#22d3ee", fillColor: "#0b1020", fillOpacity: 1 }} />)}
        {mode === "radius" && center && <Circle center={center} radius={radius} pathOptions={{ color: "#a855f7", weight: 2, fillOpacity: 0.1 }} />}
        {mode === "radius" && center && <CircleMarker center={center} radius={5} pathOptions={{ color: "#a855f7", fillOpacity: 1 }} />}
        {results?.boundary?.length > 0 && <Polygon positions={results.boundary} pathOptions={{ color: "#10b981", weight: 1.5, fillOpacity: 0.08, dashArray: "6 4" }} />}
        {(results?.photos || []).map((p) => (
          <CircleMarker key={p.id} center={[p.lat, p.lon]} radius={selected === p.id ? 8 : 5}
            pathOptions={{ color: "#ffffff", weight: 1.5, fillColor: "#10b981", fillOpacity: 1 }}>
            <Tooltip>{p.filename} · {p.session_name}</Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
